exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ico-check {\n  width: 20px !important;\n  height: 20px !important;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -ms-transform: translate(-50%, -50%);\n      transform: translate(-50%, -50%); }\n  .ico-check i {\n    font-size: 8px !important;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    -ms-transform: translate(-50%, -50%);\n        transform: translate(-50%, -50%); }\n\n:host-context(.qualifications-ag-grid) .ico-check {\n  position: relative;\n  left: auto;\n  top: auto;\n  -ms-transform: none;\n      transform: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/grid-components/boolean-check/boolean-check.component.scss
// module id = 1906
// module chunks = 66